import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Header() {

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    return (
        <div>
            <div>
                {width > 768 ? <div id="top-bar" className="top-bar">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-8">
                                <ul className="top-info text-center text-md-left">
                                    <li><i className="fas fa-map-marker-alt" />
                                        <p className="info-text">Telangana | Andhra Pradesh | India</p>
                                    </li>
                                </ul>
                            </div>
                            {/*/ Top info end */}
                            <div className="col-lg-4 col-md-4 top-social text-center text-md-right">
                                <ul className="list-unstyled">
                                    <li>
                                        <a title="Facebook" href="#">
                                            <span className="social-icon"><i className="fab fa-facebook-f" /></span>
                                        </a>
                                        <a title="Twitter" href="#">
                                            <span className="social-icon"><i className="fab fa-twitter" /></span>
                                        </a>
                                        <a title="Instagram" href="#">
                                            <span className="social-icon"><i className="fab fa-instagram" /></span>
                                        </a>
                                        <a title="Linkdin" href="#">
                                            <span className="social-icon"><i className="fab fa-github" /></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            {/*/ Top social end */}
                        </div>
                        {/*/ Content row end */}
                    </div>
                    {/*/ Container end */}
                </div>:null}
                {/*/ Topbar end */}
                {/* Header start */}
                <header id="header" className="header-one">
                    <div className="bg-white">
                        <div className="container">
                            <div className="logo-area">
                                <div className="row align-items-center">
                                    <div className="logo col-lg-3 text-center text-lg-left mb-3 mb-md-5 mb-lg-0">
                                        <a className="d-block" href="/">
                                            <img loading="lazy" src="assets/images/logo.png" width="400" alt="Adilite Group" />
                                        </a>
                                    </div>{/* logo end */}
                                    {width > 768 ?<div className="col-lg-9 header-right">
                                        <ul className="top-info-box">
                                            <li>
                                                <div className="info-box">
                                                    <div className="info-box-content">
                                                        <p className="info-box-title">Call Us</p>
                                                        <p className="info-box-subtitle">(+91) 9000-123-060</p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="info-box">
                                                    <div className="info-box-content">
                                                        <p className="info-box-title">Email Us</p>
                                                        <p className="info-box-subtitle">adilitegroup@gmail.com</p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="last">
                                                <div className="info-box last">
                                                    <div className="info-box-content">
                                                        <p className="info-box-title">Head Office</p>
                                                        <p className="info-box-subtitle">Hyderabad, India</p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="header-get-a-quote">
                                                <a className="btn btn-primary" href="/contact">Enquire Now</a>
                                            </li>
                                        </ul>{/* Ul end */}
                                    </div>:null}
                                </div>{/* logo area end */}
                            </div>{/* Row end */}
                        </div>{/* Container end */}
                    </div>
                    <div className="site-navigation">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <nav className="navbar navbar-expand-lg navbar-dark p-0">
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon" />
                                        </button>
                                        <div id="navbar-collapse" className="collapse navbar-collapse">
                                            <ul className="nav navbar-nav mr-auto">                                                
                                                <li className="nav-item"><a className="nav-link" alt="Adilite Group - Home" href="/">Home</a></li>
                                                <li className="nav-item"><a className="nav-link" alt="Adilite Group - About Us" href="/about">About Us</a></li>
                                                <li className="nav-item"><a className="nav-link" alt="Adilite Group - Products" href="/products">Products</a></li>
                                                <li className="nav-item"><a className="nav-link" alt="Adilite Group - Contact Us" href="/contact">Contact Us</a></li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                                {/*/ Col end */}
                            </div>
                            {/*/ Row end */}
                            <div className="nav-search">
                                <span id="search"><i className="fa fa-search" /></span>
                            </div>{/* Search end */}
                            <div className="search-block" style={{ display: 'none' }}>
                                <label htmlFor="search-field" className="w-100 mb-0">
                                    <input type="text" className="form-control" id="search-field" placeholder="Type what you want and enter" />
                                </label>
                                <span className="search-close">×</span>
                            </div>{/* Site search end */}
                        </div>
                        {/*/ Container end */}
                    </div>
                    {/*/ Navigation end */}
                </header>
                {/*/ Header end */}
            </div>

        </div>
    );
}

export default Header;
